import { fetchHelper } from '../../api/api'
import { wishListActions, wishListSelectors } from './wishListSlice'
import notification from '../../components/Notification/notification'
import { userSelectors } from '../../redux/userSlice'
import { fetchClassDetails, fetchCourseDetails } from '../../api/apiFunctions'
import { browseClassesSelectors } from '../Class/BrowseClasses/browseClassesSlice'
import { browseCoursesSelectors } from '../Course/BrowseCourses/browseCoursesSlice'

export const getWishList = email => async dispatch => {
    dispatch(wishListActions.getWishListRequest())
    try {
        const response = await fetchHelper(
            `Wishlist/CustomerEmail?customerEmail=${email}`
        )
        let wishList = response.data
        const itemsDataRes = await Promise.all(
            wishList.map(({ wishlistItem, wishlistItemId }) => {
                if (wishlistItem === 'course') {
                    return fetchCourseDetails(wishlistItemId)
                } else {
                    return fetchClassDetails(wishlistItemId)
                }
            })
        )
        wishList = itemsDataRes.map((_, idx) => {
            return {
                ...wishList[idx],
                data: itemsDataRes[idx],
            }
        })
        dispatch(wishListActions.getWishListRequestSuccess(wishList))
    } catch (e) {
        if (e.response?.status === 404) {
            dispatch(wishListActions.getWishListRequestError('User not found'))
        } else {
            dispatch(wishListActions.getWishListRequestError(e.message))
        }
    }
}

export const removeFromWishlist = ({ itemId, type }) => async (
    dispatch,
    getState
) => {
    const state = getState()
    const { email } = userSelectors.userDetails(state)

    const [loader] = await notification.loading({
        title: 'Removing from wishlist',
    })

    try {
        let items
        if (type === 'class') {
            items = wishListSelectors.classes(state)
        } else {
            items = wishListSelectors.courses(state)
        }
        const item = items.find(
            ({ wishlistItem, wishlistItemId }) =>
                wishlistItem === type && wishlistItemId === String(itemId)
        )
        if (item) {
            await fetchHelper.delete(
                `Wishlist/RemoveWishlistItem/CustomerEmail?customerEmail=${email}`,
                {
                    data: item.id,
                    headers: {
                        'Content-Type': 'application/json-patch+json',
                    },
                }
            )
            dispatch(
                wishListActions.removeFromWishlist({
                    type,
                    itemId: item.id,
                })
            )
        }
        //TODO: Disable button while deleting or adding
        notification.success({
            title: `Removed from wishlist`,
        })
    } catch (e) {
        //If it returns 404 then it's already removed and the user clicked the button twice or something
        if (e.response?.status !== 404) {
            notification.failure({
                title: 'Something went wrong',
                description: e.message,
            })
        }
    }
    loader()
}

export const addToWishlist = ({ itemId, type }) => async (
    dispatch,
    getState
) => {
    const state = getState()
    const { email } = userSelectors.userDetails(state)
    const classes = browseClassesSelectors.classes(state)
    const courses = browseCoursesSelectors.courses(state)

    let data

    if (type === 'class') {
        data = classes.find(({ classid }) => classid === itemId)
    } else {
        data = courses.find(({ coursecode }) => coursecode === itemId)
    }

    const [loader] = await notification.loading({
        title: 'Adding to wishlist',
    })

    try {
        const response = await fetchHelper.post(
            `Wishlist/AddToWishlist/${email}`,
            {
                wishlistItem: type,
                wishlistItemId: itemId,
            }
        )
        dispatch(
            wishListActions.addToWishList({
                item: {
                    ...response.data,
                    data,
                },
                type,
            })
        )
        notification.success({
            title: 'Added to wishlist',
        })
    } catch (e) {
        const error = {
            title: 'Something went wrong',
            description: e.message,
        }
        if (e.response?.status === 404) {
            error.description = 'User does not exist'
        }
        notification.failure(error)
    }
    loader()
}

export const isItemInWishlist = (items, id) =>
    items.some(({ wishlistItemId }) => wishlistItemId === String(id))
